import React from "react";
import { events } from "@planzone/events";

import { useMessage } from "@components/useMessage";
import { Props } from "./types";
import { Sheet } from "./sheet";
import { Form } from "./form";
import { ViewToggle } from "./viewToggle";
import styles from "./styles.scss";

function Organization({ organization }: Props) {
  const [mode, setMode] = React.useState<"read" | "write">("read");

  useMessage(
    (event) =>
      event.type === events.editOrganizationSucceeded && setMode("read"),
  );

  return (
    <div className={styles.organization}>
      {mode === "read" ? (
        <Sheet organization={organization} />
      ) : (
        <Form organization={organization} />
      )}
      <div className={styles.viewToggle}>
        <ViewToggle mode={mode} setMode={setMode} />
      </div>
    </div>
  );
}

export { Organization };
